/* eslint-disable max-len */
/* eslint-disable react/require-default-props */
import React, { FC, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { PersonalizationTagTypes } from '@btag/bt-personalization';
import { TAppState } from '../../../../../reducers';
import { IPersonalizationSingleUseTag, IPersonalizationTagDefault } from '../../../../../types/personalization';
import Button from '../../../../../componentLibrary/Button';
import Input from '../../../../../componentLibrary/Input';
import TagEdit from '../TagEdit';
import eventService from '../../../../../common/eventService';
import { COLORS } from '../../../../../common/branding/colors';
import * as Styled from './styles';
import { DRAFT_ACCESS } from '../../../../../constants/itemTypes/itemTypes';

interface IProps {
    tag: IPersonalizationTagDefault | IPersonalizationSingleUseTag;
    setHasEditOpen: (hasEditOpen: boolean) => void;
    hasEditOpen: boolean;
    hasWriteAccess: boolean;
}

const TagField: FC<IProps> = ({ tag, setHasEditOpen, hasEditOpen, hasWriteAccess }) => {
    const [isEditPopUpOpen, setIsEditPopUpOpen] = useState(false);
    const { name, fallback, type } = tag;

    useEffect(() => {
        setHasEditOpen(isEditPopUpOpen);
    }, [isEditPopUpOpen]);

    return (
        <Styled.TagFieldWrapper data-test-id={`tag-field-${name}`}>
            {isEditPopUpOpen && (
                <TagEdit tag={tag as IPersonalizationTagDefault} setIsEditPopUpOpen={setIsEditPopUpOpen} />
            )}
            <Input
                disabled
                styling={{ backgroundColor: COLORS.neutral000 }}
                type="text"
                width={152}
                value={fallback}
                label={`{{${name}}}`}
                labelFontWeight={400}
                id={`tag-fallback-${name}`}
                onChange={() => {}}
            />
            <Styled.TagButtonWrapper>
                <Button
                    id="edit-button"
                    dataTestId="tag-field-edit"
                    type="simple"
                    width={24}
                    iconSize={16}
                    icon="edit"
                    color={hasWriteAccess ? COLORS.primary300 : COLORS.neutral200}
                    hasTooltip={!hasWriteAccess}
                    tooltipPosition="left"
                    tooltipTextAlign="left"
                    tooltipPadding="8px 0"
                    tooltipFontWeight="400"
                    tooltipLineHeight="24px"
                    tooltipFontSize="15px"
                    tooltipWidth={134}
                    cursor={hasWriteAccess ? 'pointer' : 'not-allowed'}
                    label={hasWriteAccess ? 'Edit' : 'You do not have permission to edit'}
                    hasHoverEffects={hasWriteAccess}
                    marginBottom={0}
                    onClick={
                        hasWriteAccess
                            ? () =>
                                  type === PersonalizationTagTypes.DEFAULT
                                      ? setIsEditPopUpOpen(!hasEditOpen && !isEditPopUpOpen)
                                      : eventService.personalizationEdit()
                            : null
                    }
                />
            </Styled.TagButtonWrapper>
        </Styled.TagFieldWrapper>
    );
};

const mapStateToProps = (state: TAppState) => ({
    hasWriteAccess: [DRAFT_ACCESS.WRITE, DRAFT_ACCESS.OWNER].includes(_get(state, 'session.collaboration.access', '')),
});

export default connect(mapStateToProps)(TagField);
